import { connectV1Client } from './BaseRepository';

function verifyAndGetRedirectUrl(verificationDetails) {
  const { verificationId, appId, otp } = verificationDetails;
  return connectV1Client.get(`apps/${appId}/emails/${verificationId}/auth/${otp}/_authorize`);
}

export default verifyAndGetRedirectUrl;
